
import React, { useMemo, useState, JSX } from "react";
import { NewFieldTypes, NewFieldStyles } from "../../../Definitions";
import { NewInput } from "../..";

// Table
import { CellContext } from "@tanstack/react-table";
import { EditAbleCell, StyledTableCellProps } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";
import { isObject } from "lodash";

export const DivTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, cell}: CellContext<T, JSX.Element | string | undefined> & EditAbleCell<T>) => {
  const initialValue = useMemo(() => getValue(), [getValue]);
  const [value, setValue] = useState(initialValue);

  if (isObject(value)) {
    return (
      <div>
        {value}
      </div>
    )
  }

  const divStyle = divStyleOverride ? divStyleOverride(styleOverrideOnValue ? value : row.original.id) : undefined;

  const onBlur = () => {
    if (value !==initialValue) {
      table.options.meta?.updateData(row.original.id, column.id, value, row)
    }
  }
  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return <StyledDivCell staticColumn={isStatic} key={cell.id} keyPass={cell.id+"Input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value, style: divStyle}} />
}

const StyledDivCell = <T extends IdentifiableRow> ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell<T>) => {
  if (canEdit) {
    if (staticColumn) { 
      return (
        <div style={{ ...cellData.style }} key={keyPass}>
          {String(cellData.value)}
        </div>
      );
    } else {
      return (
        <NewInput
          onBlur={onBlur}
          key={keyPass}
          onChange={onChange}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyTertiary,
            fieldType: NewFieldTypes.tertiaryField,
            fieldWidth: "100%"
          }}
          valueOverrides={{
            defaultValue: cellData.value,
            valueType: "string"
          }}
          // keyPass={keyPass}
          // context={cellData.value}
          // fieldStyle={FieldStyles.greyTertiary}
          // fieldType={FieldTypes.editField}
          // textStart
          // inTable
          // inputType="string"
          // onBlur={onBlur}
          // initialIsFocused={!cellData.value ? true: false}
        />
      );
    }
  }

  return (
    <div style={cellData.style} key={keyPass}>
      {String(cellData.value)}
    </div>
  )
} 
